module.exports = __webpack_public_path__ + "media/images/icon__locked@3x-c5ad061e62e3893d1cb7013e81f62356.png";